<template>
  <v-card flat class="list-item">
    <v-card-title class="pt-0 pb-1">
        <v-list-item-action>
          <v-icon color="primary" v-if="icon">{{ icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <slot></slot>
          <v-list-item-subtitle class="list-item__subtitle">{{ subtitle }}</v-list-item-subtitle>
          <div v-html="getTitle" class="list-item__title" :class="{ multiline: multiline }"></div>
        </v-list-item-content>
    </v-card-title>
  </v-card>
</template>

<script>
  export default {
    name: 'ListItem',
    props: {
      icon: String,
      subtitle: String,
      multiline: Boolean,
      title: [String, Number],
      defaultValue: {
        type: String,
        default: 'NA',
      },
    },
    computed: {
      getTitle() {
        return (this.title) ? this.title : this.defaultValue;
      },
    },
  };
</script>

<style scoped lang="scss">
  .list-item {
    &__subtitle {
      font-size: 12px;
    }
    &__title {
      font-size: 15px;
      &.multiline {
        white-space: pre-wrap;
      }
    }
  }
</style>
